export const demoCall = {
  incomingBanner: {
    title: "無料通話のお誘い",
    appeal: "🎁 無料でビデオ通話を体験しませんか？",
    onceBadge: "🔥 初回1回限り",
    countdown: ({ seconds }: { seconds: number }) => `残り${seconds}秒`,
    label: "📞 無料通話が着信中",
    freeBadge: "無料",
    accept: "応答",
    decline: "拒否",
  },
  inCall: {
    header: "無料通話中",
    end: "終了",
    connecting: "接続中…",
  },
} as const;
